import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { AppConstants } from '@core/constants/app';
import * as moment from 'moment';
import { Params } from "@angular/router";
import {UtilService} from "@core/data/util.service";
import {take} from "rxjs/operators";

@Injectable({
  providedIn: 'root',
})
export class ApplicationConfigService {

  private subject = new BehaviorSubject({
    applicationId: null,
    requestedEffectiveDate: null,
    marketingId: '',
    revision: null,
  });
  private readonly applicationConfig$: Observable<Params>;

  constructor(protected utilService: UtilService) {
    this.applicationConfig$ =  this.subject.asObservable();
  }

  setConfig(applicationId: number, requestedEffectiveDate: string) {
    this.utilService.getMedicareEnrollmentConfig()
      .pipe(take(1))
      .subscribe(response => {
        const effectiveDateMoment = moment(requestedEffectiveDate);
        this.subject.next({
          applicationId,
          requestedEffectiveDate,
          marketingId: effectiveDateMoment.isValid() ? AppConstants.APPLICATION_MATERIAL_IDS[effectiveDateMoment.year()] : '',
          revision: response.REVISION[effectiveDateMoment.year()]
        });
      });
  }

  clearConfig() {
    this.subject.next({
      applicationId: null,
      requestedEffectiveDate: null,
      marketingId: '',
      revision: null,
    });
  }

  getConfig(): Observable<Params> {
    return this.applicationConfig$;
  }
}
